import styled from "styled-components";

export const RigthSideContent = styled.div`
  width: fit-content;
  margin: 0 auto;

  > h1 {
    color: #1d1d1b;
    font-size: 70px;
    font-style: normal;
    font-weight: 700;
    line-height: 84px;
    margin-bottom: 1rem;
  }

  > p {
    color: #a3a3a3;
    margin-bottom: 2rem;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;
